import { render, staticRenderFns } from "./AppRelationDocuments.vue?vue&type=template&id=52a7ab2f&"
import script from "./AppRelationDocuments.vue?vue&type=script&lang=js&"
export * from "./AppRelationDocuments.vue?vue&type=script&lang=js&"
import style0 from "./AppRelationDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports